$shm_hitalama_components_source $shm_textarea_code
	definition $shm_hitalama_map_widget_entity_custom
	kind \demo
	failure \
	saving? false
	sidebar_showed true
